import { axiosInstance } from './api';

/**
 * Child Chapters API Service
 *
 * Backend endpoints are all under /api/child-chapters/ with person_id as a query param.
 */

/**
 * Get the child profile (age band, birth info, transition state, etc.)
 */
export async function getChildProfile(personId) {
  const response = await axiosInstance.get(`/child-chapters/child_profile/?person_id=${personId}`);
  return response.data;
}

/**
 * Create a child profile and generate initial chapters.
 */
export async function createChildProfile(personId, data) {
  const response = await axiosInstance.post('/child-chapters/generate_child_chapters/', {
    person_id: personId,
    ...data,
  });
  return response.data;
}

/**
 * Update a child profile (e.g. set birth date after initial creation)
 */
export async function updateChildProfile(personId, data) {
  const response = await axiosInstance.patch(`/child-chapters/child_profile/?person_id=${personId}`, data);
  return response.data;
}

/**
 * Get all chapters for a child.
 * Uses the existing chapters endpoint filtered by person_id.
 */
export async function getChildChapters(personId) {
  const response = await axiosInstance.get(`/chapters/?person_id=${personId}`);
  return response.data;
}

/**
 * Evaluate / re-evaluate the child's age band.
 */
export async function evaluateBand(personId) {
  const response = await axiosInstance.post('/child-chapters/evaluate_band/', {
    person_id: personId,
  });
  return response.data;
}

/**
 * Acknowledge (dismiss) a band transition notice.
 */
export async function acknowledgeTransition(personId) {
  const response = await axiosInstance.post('/child-chapters/acknowledge_transition/', {
    person_id: personId,
  });
  return response.data;
}

/**
 * Get prompts for a specific child chapter.
 * @param {string} personId
 * @param {string} bandKey - e.g. 'infant', 'young_child'
 * @param {number} chapterIndex - 1-5
 */
export async function getChapterPrompts(personId, bandKey, chapterIndex) {
  const response = await axiosInstance.get(
    `/child-chapters/child_chapter_prompts/?person_id=${personId}&band_key=${bandKey}&chapter_index=${chapterIndex}`
  );
  return response.data;
}

/**
 * Dismiss the "missing birth year" prompt for a child.
 */
export async function dismissBirthYearPrompt(personId) {
  const response = await axiosInstance.post('/child-chapters/acknowledge_transition/', {
    person_id: personId,
  });
  return response.data;
}
